import * as numeral from 'numeral'

const FormatNumber = function (input, format, prefix) {
  return (typeof prefix === 'undefined' ? '£' : '') + numeral(input).format(format);
}

export default {
  install(Vue) {
    Vue.filter('commas', function (value) {
      return FormatNumber(value, '0,0', '');
    });
    Vue.filter('currency', function (value, prefix) {
      return FormatNumber(value, '0,0.00', prefix);
    });
    Vue.filter('prefix', function (value, prefix) {
      return `${prefix}${value}`;
    });
  },
};